import { Box, Typography } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const QuickAccessWidget = ({ actions = [] }) => {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography
        sx={{
          fontFamily: '"Barlow Condensed", system-ui, sans-serif',
          fontSize: '1rem',
          fontWeight: 600,
          color: '#1d1f20',
          mb: 2,
          letterSpacing: '-0.015em',
        }}
      >
        Accesos Rapidos
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(2, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: `repeat(${Math.max(actions.length, 1)}, 1fr)`,
          },
          gap: 2,
        }}
      >
        {actions.map((action, index) => (
          <Box
            key={index}
            onClick={() => navigate(action.path)}
            sx={{
              bgcolor: '#f2f2f3',
              borderRadius: 0,
              p: 2.25,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              border: '1px solid rgba(29,31,32,0.16)',
              transition: 'background-color 0.15s ease',
              '&:hover': {
                bgcolor: 'rgba(29,31,32,0.07)',
                '& .quick-arrow': {
                  opacity: 1,
                  transform: 'translateX(0)',
                },
              },
            }}
          >
            <Box
              className="quick-icon-box"
              sx={{
                width: 40,
                height: 40,
                borderRadius: 0,
                border: '1px solid rgba(29,31,32,0.16)',
                bgcolor: 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                '& svg': {
                  fontSize: 20,
                  color: '#416180',
                },
              }}
            >
              {action.icon}
            </Box>

            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  fontFamily: '"Barlow Condensed", system-ui, sans-serif',
                  fontSize: '1rem',
                  fontWeight: 600,
                  color: '#1d1f20',
                  letterSpacing: '-0.015em',
                  lineHeight: 1.3,
                }}
              >
                {action.title}
              </Typography>
              {action.badge && (
                <Typography sx={{ fontSize: '0.73rem', color: 'rgba(29,31,32,0.55)', mt: 0.25, fontWeight: 500 }}>
                  {action.badge}
                </Typography>
              )}
            </Box>

            <ArrowForward
              className="quick-arrow"
              sx={{
                fontSize: 17,
                color: '#5980a6',
                opacity: 0,
                transform: 'translateX(-6px)',
                transition: 'all 0.2s ease',
                flexShrink: 0,
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default QuickAccessWidget;
